export default "__VITE_ASSET__5250fe5e__"